import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const ColumnFlowsQueryGql: DocumentNode = gql`
query ColumnFlowsQuery($columnId: ID!, $first: Int!, $offset: Int!) {
  columns(filter: { id: $columnId }) {
    referencedByFlowColumnInputFieldConnection(first: $first, offset: $offset, orderBy: { field: NAME, direction: ASC }) {
      totalCount
      nodes {
        id
        name
        flow {
          vizportalUrlId
          name
        }
      }
    }
  }
}
`;
